/**
 * Client-side helpers for the health metrics and stats timeseries endpoints
 * (ENR-813). Both endpoints share the same response envelope so the
 * dashboard can render CloudWatch and Postgres-backed series through one
 * pipeline.
 */

export interface MetricPoint {
  timestamp: string;
  value: number;
}

export interface MetricSeries {
  id: string;
  points: MetricPoint[];
}

export interface MetricsResponse {
  from: string;
  to: string;
  period: number;
  series: MetricSeries[];
}

export interface MetricsQueryOptions {
  from: string;
  to: string;
  series: string[];
}

export async function fetchHealthMetrics(
  baseUrl: string,
  opts: MetricsQueryOptions
): Promise<MetricsResponse> {
  const params = new URLSearchParams();
  params.set("from", opts.from);
  params.set("to", opts.to);
  for (const id of opts.series) {
    params.append("series", id);
  }
  const res = await fetch(`${baseUrl}/health/metrics?${params.toString()}`);
  if (!res.ok) {
    throw new Error(`fetchHealthMetrics failed with status ${res.status}`);
  }
  return (await res.json()) as MetricsResponse;
}

export async function fetchStatsTimeseries(
  baseUrl: string,
  opts: MetricsQueryOptions
): Promise<MetricsResponse> {
  const params = new URLSearchParams();
  params.set("from", opts.from);
  params.set("to", opts.to);
  for (const id of opts.series) {
    params.append("series", id);
  }
  const res = await fetch(`${baseUrl}/stats/timeseries?${params.toString()}`);
  if (!res.ok) {
    throw new Error(`fetchStatsTimeseries failed with status ${res.status}`);
  }
  return (await res.json()) as MetricsResponse;
}
